import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addFieldSuccess,
  addFieldFailure,
  //
  deleteFieldSuccess,
  deleteFieldFailure,
  //
  editFieldSuccess,
  editFieldFailure,
  //
  fetchFieldsSuccess,
  fetchFieldsFailure,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
  toggleFieldAdd,
  updateFieldOrderSuccess,
  updateFieldOrderFailure,
} from "./actions";
import {
  ADD_FIELD,
  DELETE_FIELD,
  EDIT_FIELD,
  FETCH_FIELDS,
  GET_VIEW_DATA,
  UPDATE_FIELD_ORDER,
} from "./constants";

export function* fetchFieldsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload?.data ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(api(token).get, `/api/template?${query}`);
    yield put(fetchFieldsSuccess(data));
  } catch (e) {
    yield put(fetchFieldsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching template list!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/template/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching template data!"));
  }
}

export function* addFieldSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/form-field/add`, payload);
    if (data) {
      yield put(successAlert("Field created successfully!"));
      yield put(addFieldSuccess());
      yield put(toggleFieldAdd({ open: false }));
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(addFieldFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editFieldSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/form-field/edit/${payload.id}`,
      payload,
    );
    if (data) {
      yield put(successAlert("Field updated successfully!"));
      yield put(editFieldSuccess());
      yield put(toggleFieldAdd({ open: false }));
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(editFieldFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteFieldSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { id, params } = payload;
  const query = QueryString.stringify(params);
  try {
    const data = yield call(
      api(token).delete,
      `/api/form-field/${id}?${query}`,
    );
    if (data) {
      yield put(successAlert("Field deleted successfully!"));
      yield put(deleteFieldSuccess());
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteFieldFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* updateFieldOrderSaga({ payload, onStepUpdate }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/form-field-sequence`,
      payload,
    );
    if (data) {
      yield put(successAlert("Field order updated successfully!"));
      yield put(updateFieldOrderSuccess());
      typeof onStepUpdate === "function" && onStepUpdate();
    }
  } catch (e) {
    yield put(updateFieldOrderFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchFieldsFlow() {
  yield takeEvery(FETCH_FIELDS, fetchFieldsSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addFieldFlow() {
  yield takeEvery(ADD_FIELD, addFieldSaga);
}
export function* editFieldFlow() {
  yield takeEvery(EDIT_FIELD, editFieldSaga);
}
export function* deleteFieldFlow() {
  yield takeEvery(DELETE_FIELD, deleteFieldSaga);
}
export function* updateFieldOrderFlow() {
  yield takeEvery(UPDATE_FIELD_ORDER, updateFieldOrderSaga);
}

export default function* FieldSaga() {
  yield all([
    fetchFieldsFlow(),
    addFieldFlow(),
    editFieldFlow(),
    deleteFieldFlow(),
    getViewDataFlow(),
    updateFieldOrderFlow(),
  ]);
}
